import { queryClient, useMutation } from '../../ReactQuery';
import { put } from '../../redux/api';
import { CURRENT_PLAN_QUERY_KEY } from './useGetCurrentPlan';

function synchronizeSubscription(): Promise<void> {
  return put<void, void>('/api/organizations/subscription/sync', undefined)
    .then((resp) => {
      if (resp.status >= 300) {
        throw new Error('Error while synchronizing subscription.');
      }

      return undefined;
    });
}

/**
 * Mutation used to update the current plan the organizatio is in.
 */
export function useSynchronizeSubscription() {
  return useMutation({
    mutationFn: synchronizeSubscription,
    retry: 0,
    onSuccess: () => {
      queryClient.invalidateQueries(CURRENT_PLAN_QUERY_KEY);
    },
  });
}
